const COOKIEBOT_COOKIE = 'CookieConsent';
const CONSENT_EVENTS = ['CookiebotOnLoad', 'CookiebotOnConsentReady', 'CookiebotOnAccept', 'CookiebotOnDecline'] as const;
const ONE_YEAR_IN_MS = 31536000000;

export const CONSENT_MIRROR_COOKIE = 'cookie_consent_v1';
export const CONSENT_APPLIED_COOKIE = 'cookie_consent_applied_v1';

const readRawCookie = (name: string) =>
  document.cookie
    .split('; ')
    .find((cookie) => cookie.startsWith(`${name}=`))
    ?.slice(name.length + 1);

// Every host we serve sits one label under its apex (www.menguin.com → menguin.com); localhost has none
const getApexDomain = () => {
  const labels = window.location.hostname.split('.');

  return labels.length > 1 ? labels.slice(-2).join('.') : null;
};

const utcOf = (decision: string) => Number(/utc(?::|%3A)([0-9]+)/i.exec(decision)?.[1] ?? 0);

// Cookiebot's bare -1 carries no utc, so the value itself identifies that decision
const keyOf = (decision: string) => String(utcOf(decision) || decision);

// The copies live exactly as long as Cookiebot's own consent does
const expiryOf = (decision: string) => {
  const utc = utcOf(decision);

  return utc ? `; expires=${new Date(utc + ONE_YEAR_IN_MS).toUTCString()}` : `; max-age=${ONE_YEAR_IN_MS / 1000}`;
};

/** Mirrors this host's Cookiebot decision to the apex Consent Mirror the app server reads, or clears it once the decision is withdrawn here. */
export const mirrorCookieConsent = () => {
  const decision = readRawCookie(COOKIEBOT_COOKIE);
  const apexDomain = getApexDomain();
  const scope = apexDomain ? `; domain=${apexDomain}` : '';
  const secure = apexDomain ? '; secure' : '';

  if (decision) {
    document.cookie = `${CONSENT_MIRROR_COOKIE}=${decision}; path=/; samesite=lax${scope}${secure}${expiryOf(decision)}`;
    document.cookie = `${CONSENT_APPLIED_COOKIE}=${keyOf(decision)}; path=/; samesite=lax${secure}${expiryOf(decision)}`;
  } else {
    document.cookie = `${CONSENT_MIRROR_COOKIE}=; path=/; max-age=0${scope}`;
  }
};

export const startConsentMirror = () => {
  mirrorCookieConsent();
  CONSENT_EVENTS.forEach((event) => window.addEventListener(event, mirrorCookieConsent));
};
